// Interfaces
import { Stack } from "@mui/material";
import { ISideTreeInformation } from "../../interfaces";

// Components
import InformationVariant from "./InformationVariant";

const getDisplay = (display: boolean) => (display ? "flex" : "none");
const getSxProperties = (sx: object | null, position = "absolute") => {
	if (!sx) {
		return {
			position,
			left: "-55px",
		};
	}
	return sx;
};

export default function SideTreeInformation(props: Readonly<ISideTreeInformation>) {
	const { sx = null, position = "absolute", display: displayAttr = false } = props;
	const display = getDisplay(displayAttr);
	const sxToUse = getSxProperties(sx, position);

	return (
		<Stack direction={"row"} sx={{ ...sxToUse, display }}>
			<InformationVariant {...props} />
		</Stack>
	);
}
